module.exports = __webpack_public_path__ + "static/BeVietnam-Light-508cf149dff31d35bd472fa2f65d1ca6.woff2";